import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Quote} from '../model/quote';
import {AbstractQuoteService, quotesErrorSelector} from './abstract-quote.service';
import {catchError, map, tap} from 'rxjs/operators';
import {QuoteEntity} from '../model/quote-entity';
import {QuoteAddProductCommand, QuoteEditProductCommand, QuoteProductCommand} from '../model/quote-commands';

@Injectable()
export class QuoteProductService extends AbstractQuoteService {
    constructor(private http: HttpClient) {
        super();
    }

    addProductToQuote(quoteAddProductCommand: QuoteAddProductCommand): Observable<Quote> {
        const requestBody = {
            productId: quoteAddProductCommand.product.id,
            quantity: quoteAddProductCommand.quantity
        };

        const url = this.determineQuoteProductsResourceUrl(quoteAddProductCommand.quote);
        return this.http.post<QuoteEntity>(url, requestBody).pipe(
            tap(response => console.log(response)),
            map(quote => this.convertToQuote(quote)),
            catchError(err => quotesErrorSelector(err))
        );
    }

    editProductFromQuote(quoteEditProductCommand: QuoteEditProductCommand): Observable<Quote> {
        const requestBody = {
            position: quoteEditProductCommand.position,
            quantity: quoteEditProductCommand.quantity
        };

        const url = this.determineQuoteProductResourceUrl(quoteEditProductCommand.quote, quoteEditProductCommand.product);
        return this.http.put<QuoteEntity>(url, requestBody).pipe(
            tap(response => console.log(response)),
            map(quote => this.convertToQuote(quote)),
            catchError(err => quotesErrorSelector(err))
        );
    }

    deleteProductFromQuote(quoteProductCommand: QuoteProductCommand): Observable<Quote> {
        const url = this.determineQuoteProductResourceUrl(quoteProductCommand.quote, quoteProductCommand.product);
        return this.http.delete<QuoteEntity>(url).pipe(
            tap(response => console.log(response)),
            map(quote => this.convertToQuote(quote)),
            catchError(err => quotesErrorSelector(err))
        );
    }
}
